import * as _ from 'underscore';
import { ContentDefinitions } from './models/ContentDefinitions';
import { ContentType, OmniboxConfiguration } from "./models/Types";

export const enum HostComponentOptions {
    VPC = 'VPC',
    ConnectTo = 'Connect To'    // https://sourcegraph.prod.tableautools.com/connect-ui/connect-pane-plugin-tableau-server/-/blob/src/connectto/Omnibox/CustomizedOmnibox.tsx?L49
}

export const defaultOmniboxConfiguration: OmniboxConfiguration = {
    apiHost: '',
    showOwnerLinks: false,
    contentTypesForQuickLinks: [ContentType.view, ContentType.workbook, ContentType.metric, ContentType.collection, ContentType.unifieddatasource],
    requiredContentTypes: Object.keys(ContentDefinitions).map(item => item as ContentType),
    hostComponent: HostComponentOptions.VPC,
    pastQueryMaxCount: 4,
    contentSuggestionMaxCount: 6,
    emptyStateContentSuggestionMaxCount: 6,
    jumpBackInMaxCount: 5,
    searchFieldTestId:'omnibox'
};

export class OmniboxConfigurationService {
    public configuration: OmniboxConfiguration
    public static instance = new OmniboxConfigurationService();

    constructor() {
        this.reset();
    }

    public initialize(configuration: OmniboxConfiguration) {
        this.configuration = _.extend({}, defaultOmniboxConfiguration, configuration);
    }

    public reset() {
        this.configuration = _.extend({}, defaultOmniboxConfiguration);
    }
}